import {
    createUnknownComponentVNode as _$cc,
    extend as _$ex,
    EMPTY_OBJ as _$em,
} from 'intact';
import {Sender, Select, Option} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$cc(Sender, {
        'fileView': 'media',
        'uploadButton': 'list',
        'uploadProps': {accept: this.getUploadAccept(), multiple: true, limit: 6},
        '$blocks': function($blocks) {
            var _$blocks = {}, __$blocks = _$ex({}, $blocks);
            return (
                (
                    (_$blocks['configure'] = function($super) {
                        return (
                            _$cc(Select, {
                                'size': 'small',
                                'width': 92,
                                'children': [
                                    _$cc(Option, {
                                        'value': 'image',
                                        'children': '图片'
                                    }),
                                    _$cc(Option, {
                                        'value': 'video',
                                        'children': '视频'
                                    })
                                ],
                                'ev-$model:value': function($v) {
                                    $this.set('mediaType', $v);
                                },
                                'value': $this.get('mediaType')
                            })
                        );
                    }),
                    (__$blocks['configure'] = function($super, data) {
                        var block = $blocks['configure'];
                        var callBlock = function() {
                            return _$blocks['configure'].call($this, $super, data);
                        };
                        return block ?
                            block.call($this, callBlock, data) :
                            callBlock();
                    })
                ),
                __$blocks
            );
        }.call($this, _$em),
        'ev-$model:value': function($v) {
            $this.set('value', $v);
        },
        'value': $this.get('value'),
        'ev-$model:attachments': function($v) {
            $this.set('attachments', $v);
        },
        'attachments': $this.get('attachments')
    });
};